<template>
    <div class="filter-container">
        <div class="block">
            <div class="container">
                <h3>{{$t('common.markets')}}</h3>
                <a
                    :key="market.id"
                    v-for="market in markets"
                    @click="handleClick(market)"
                    :class="['filter-cta', {
                        active: market.id === marketId
                    }]"
                >
                    <span class="underline">{{market.name}}</span>
                </a>
            </div>
            <div class="container">
                <h3>Techniques</h3>
                <a
                    :key="market.id"
                    v-for="market in techniques"
                    @click="handleClick(market)"
                    :class="['filter-cta', {
                        active: market.id === techniqueId
                    }]"
                >
                    <span class="underline">{{market.name}}</span>
                </a>
            </div>
            <div class="container">
                <h3>Zone géographique</h3>
                <CountryList
                    @toggle-region="(region) => toggleRegion(region)"
                    @handle-click="handleClick"
                    :key="region.name"
                    v-for="region in regions"
                    :region="region"
                    :current-region="currentRegion"
                    :filtered-countries="filteredCountries"
                    :country-id="countryId"
                />
            </div>
            <div class="container country-list-standalone">
                <a
                    :key="market.id"
                    v-for="market in filteredCountries"
                    @click="handleClick(market)"
                    :class="['filter-cta', {
                        active: market.id === countryId
                    }]"
                >
                    <span class="underline">{{market.name}}</span>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import { getFilters } from '@/store/api/index'
import CountryList from '@/views/Projects/CountryList'
export default {
    components: {
        CountryList
    },
    props: {
        filters: {
            type: Object,
            default() {}
        }
    },
    data() {
        return {
            markets: [],
            techniques: [],
            countries: [],
            currentRegion: null
        }
    },
    computed: {
        marketId() {
            return this.filters.market ? this.filters.market.id : null
        },
        techniqueId() {
            return this.filters.technique ? this.filters.technique.id : null
        },
        countryId() {
            return this.filters.country ? this.filters.country.id : null
        },
        filteredCountries() {
            return this.countries.filter(_ => _.region === this.currentRegion)
        },
        regions() {
            const regions = this.countries.reduce((acc, cur) => {
                const region = acc.find(region => region.name === cur.region)
                if(!region) {
                    acc.push({
                        name: cur.region,
                        countries: [
                            cur
                        ]
                    })
                } else {
                    region.countries.push(cur)
                }
                return acc
            }, [])
            return regions
        }
    },
    created() {
        const lang = this.$route.params.locale
        getFilters({lang})
            .then(res => {
                this.markets = res.markets
                this.techniques = res.techniques
                this.countries = res.countries
                this.checkHash()
            })
    },
    methods: {
        checkHash() {
            const key = this.$route.hash.replace('#','');
            const market = this.markets.find(_ => {
                return _.customslug === key
            })
            if(market) {
                const { type, id, name } = market
                this.$emit('updateFilter', {
                    type,
                    id,
                    name
                })
            }
        },
        toggleRegion(region) {
            const {name} = region
            this.currentRegion = name === this.currentRegion ? null : name
            this.$emit('updateFilter', {
                type: 'region',
                id: region.countries.map(_ => _.id).join(),
                name,
                active: this.currentRegion
            })
        },
        handleClick(market) {
            const { type, id, name, customslug } = market
            this.$emit('updateFilter', {
                type,
                id,
                name,
                customslug
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.filter-container
    background-color: white
    border-bottom: 1px solid #e0e1e3
    border-top: 1px solid #e0e1e3
    margin-top: -30px
.block
    display: flex
    padding-top: 3%
    padding-bottom: 3%
    flex-wrap: wrap

.container
    flex: 1
    @include media-breakpoint-down($hd)
        min-width: 50%
    @include media-breakpoint-down($md)
        min-width: 100%
        &.country-list-standalone
            display: none
h3
    font-size: 28px
    font-weight: 500
    color: #636772
    margin-bottom: 1.5em
    @include media-breakpoint-down($hd)
        margin-bottom: 4%
        margin-top: 6%
.filter-cta
    font-size: 17px
    font-weight: 500
    color: #636772
    display: block
    cursor: pointer
    padding-bottom: 8px
    .underline
        line-height: 2.3529411765em
    &.active
        color: #ff2b2a
</style>
